import { createContext } from 'react';

import { AppConfigErrorScreen } from '../../features/app-config/app-config-error-screen/cdm-app-config-error-screen';
import { useLocations } from '../../features/app-config/hooks/cdm-use-locations';

export interface SelectedLocationProviderContextInterface {
  useLocations: typeof useLocations;
  AppConfigErrorScreen: typeof AppConfigErrorScreen;
}

const defaultValue: SelectedLocationProviderContextInterface = {
  useLocations,
  AppConfigErrorScreen,
};

export const SelectedLocationProviderContext =
  createContext<SelectedLocationProviderContextInterface>(defaultValue);
